import React, { useMemo } from 'react';
import { forwardRef } from '@chakra-ui/react';
import { Icon } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import DisplaySavedProject from 'components/widgets/SaveProject/DisplaySavedProject';
import {
  MonitoringColors,
  PassedColors,
  QualifiedColors,
} from 'components/widgets/SaveProject/savedStateColors';
import type { ButtonProps } from '@mercator-gcp/grout';

type TSavedMenuButtonProps = {
  isUnstyled?: boolean;
  sx?: ButtonProps['sx'];
  showLabel?: boolean;
  isWatched?: boolean;
  isStarred?: boolean;
  isHidden?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const SavedMenuButton = forwardRef<TSavedMenuButtonProps, 'div'>(
  (
    {
      isUnstyled = false,
      sx = {},
      showLabel = true,
      isWatched = false,
      isStarred = false,
      isHidden = false,
      onClick,
    },
    ref,
  ) => {
    const buttonVariant = useMemo(
      () => (isUnstyled ? 'unstyled' : 'styled'),
      [isUnstyled],
    );

    return (
      <FlexRow ref={ref}>
        {isStarred && (
          <DisplaySavedProject
            variant={buttonVariant}
            onClick={onClick}
            sx={sx}
            label={showLabel ? 'Qualified' : ''}
            colorScheme={QualifiedColors}
            icon={<Icon name={Icon.Name.StarFilled} fill={QualifiedColors.foreground} />}
          />
        )}
        {isWatched && (
          <DisplaySavedProject
            variant={buttonVariant}
            onClick={onClick}
            sx={sx}
            label={showLabel ? 'Monitoring' : ''}
            colorScheme={MonitoringColors}
            icon={<Icon name={Icon.Name.Eye} fill={MonitoringColors.foreground} />}
          />
        )}
        {isHidden && (
          <DisplaySavedProject
            variant={buttonVariant}
            onClick={onClick}
            sx={sx}
            label={showLabel ? 'Passed' : ''}
            colorScheme={PassedColors}
            icon={<Icon name={Icon.Name.EyeHide} fill={PassedColors.foreground} />}
          />
        )}
      </FlexRow>
    );
  },
);

export default SavedMenuButton;
